/* eslint-disable */
import { v4 } from 'uuid'
import api from '@/api/api'
import { checkError } from '../utils/checkError'
import { sendFile } from '../utils/sendFile'
import moment from 'moment'

const submit = async (template, planilha, error, table) => {
  const id_file = await sendFile(table);
  const submitPlan = planilha.data.map(row => {
    return {
      data_referencia: row['0.0'].value,
      data_lancamento: row['0.1'].value,
      fornecedor_id: row['0.2'].value,
      fornecedor_cnpj: row['0.3'].value,
      associado_id: row['0.4'].value,
      associado_cnpj: row['0.5'].value,
      valor_faturamento: row['0.6'].value ? row['0.6'].value.replaceAll('.', '').replaceAll(',', '.') : 0,
      valor_devolucao: row['0.7'].value ? row['0.7'].value.replaceAll('.', '').replaceAll(',', '.') : 0,
      evento_id: row['0.8'].value,
    }
  })

  try {
    let envioPlan = []
    let retorno = []
    let nContador = 0
    let inseridos = 0
    let atualizados = 0
    let qtdErros = 0
    let totalRelatorio = 0

    for (let i = 0, len = submitPlan.length; i < len; i++) {
      envioPlan.push(submitPlan[i])

      ++nContador

      if (nContador >= 3000 || (i + 1) >= len) {
        try {
          let response = await api.cadastrarEntidade({ lancamentoFaturas: envioPlan, erro: error }, 'lancamentoFaturamento/batch')

          inseridos += response[0].inseridos
          atualizados += response[0].atualizados
          qtdErros += response[0].qtdErros
          totalRelatorio += response[0].totalRelatorio
        }
        catch (e) {
          retorno = [...retorno, ...e.errors]
          inseridos += e.inseridos
          atualizados += e.atualizados
          qtdErros += e.qtdErros
          totalRelatorio += e.totalRelatorio

        }
        envioPlan = []
        nContador = 0
      }
    }
    envioLog(inseridos, atualizados, qtdErros, totalRelatorio, id_file)
    return [retorno]
  } catch (err) {
    return [err];
  }
}

const formatData = (data) => {
  let data_formatada = []
  data.forEach(row => {
    let dataReferencia = "";
    let dataLancamento = "";

    if (row.data_referencia) {
      const m = moment(String(row.data_referencia), [
        "YYYY-MM-DD",
        "DD/MM/YYYY",
        "D/M/YYYY",
        "DD-MM-YYYY",
        "D-M-YYYY",
        moment.ISO_8601
      ], true);
      if (m.isValid()) {
        dataReferencia = m.format("MM/DD/YYYY");
      }
    }

    if (row.data_lancamento) {
      const m = moment(String(row.data_lancamento), [
        "YYYY-MM-DD",
        "DD/MM/YYYY",
        "D/M/YYYY",
        "DD-MM-YYYY",
        "D-M-YYYY",
        moment.ISO_8601
      ], true);
      if (m.isValid()) {
        dataLancamento = m.format("MM/DD/YYYY");
      }
    }

    data_formatada.push({
      '0.0': { 
        value: dataReferencia,  ...checkError(row, "data_referencia")
      },
      '0.1': { 
        value: dataLancamento, ...checkError(row, 'data_lancamento') 
      },
      '0.2': { value: row.fornecedor_id, ...checkError(row, 'fornecedor_id') },
      '0.3': { value: row.fornecedor_cnpj, ...checkError(row, 'fornecedor_cnpj') },
      '0.4': { value: row.associado_id, ...checkError(row, 'associado_id') },
      '0.5': { value: row.associado_cnpj, ...checkError(row, 'associado_cnpj') },
      '0.6': { value: row.valor_faturamento, ...checkError(row, 'valor_faturamento') },
      '0.7': { value: row.valor_devolucao, ...checkError(row, 'valor_devolucao') },
      '0.8': { value: row.evento_id, ...checkError(row, 'evento_id') },
    })
  })
  return data_formatada
}

async function envioLog (inseridos, atualizados, qtdErros, totalRelatorio, id_file) {
  const log = `Cadastrados ${inseridos} Atualizados ${atualizados}, Total Relatório ${totalRelatorio}, Erros ${qtdErros}`
  api.cadastrarEntidade({ log: log, tipo_integracao: 6, id_file: id_file }, 'integracaologs').then()
}

export default {
  submit,
  formatData,
}